export var DefaultClientConfig = {
    isBackButtonDisplayed: false,
    isJoinUsButtonDisplayed: false
};
export var ECommerceClientConfig = {
    isBackButtonDisplayed: true,
    isJoinUsButtonDisplayed: true
};
export var getConfigurationClientId = function(clientId) {
    switch(clientId){
        case 'ECommerce-V9':
            return ECommerceClientConfig;
        default:
            return DefaultClientConfig;
    }
};
